import { compose } from 'lodash/fp';

import { maskedInputFactory } from '../maskedInput';

import DateMaskInput from './DateMaskInput';

export const createDateMask = compose(DateMaskInput, maskedInputFactory);

export * from './constants';
export * from './helpers';
export * from './types';
